import React from 'react';
import { useLocale } from 'components/special/LanguageProvider';


const Footer = ({onContactClick}) => {
  const { t } = useLocale();

  const performContactClick = () => {
    if (onContactClick) {
      onContactClick();
    }
  };

  return (
    <footer className='main-footer' id='main-footer'>
      <div className='support'>
        <div className='inner'>
          <a
            className='icon-info2'
            href={t('footer_aboutCreditinfo_link')}
            target='_blank'
            rel='noopener noreferrer'
          >
            {t('footer_aboutCreditinfo')}
          </a>
          {!onContactClick ? (
            <a href='mailto:creditinfo@creditinfo.is' className='icon-envelope'>
              {t('footer_contactUs')}
            </a>
          ) : (
            <span className='icon-envelope' onClick={performContactClick}>
              {t('footer_contactUs')}
            </span>
          )}
        </div>
        <div className='powered-by' style={{ display: 'none' }}>
          <img
            src={t('footer_powered_by_logo_url')}
            height='50'
            alt={t('footer_powered_by_alt')}
          />
        </div>
      </div>
    </footer>
  );

}

export default Footer;
